import { Language } from '@shared/types/language'

interface TrainingListQueryKeyParams {
	search?: string
	lang?: Language
	scope?: string
}

export const trainingQueryKeys = {
	all: ['training'] as const,
	lists: () => [...trainingQueryKeys.all, 'list'] as const,
	list: (params: TrainingListQueryKeyParams = {}) =>
		[...trainingQueryKeys.lists(), params] as const,
	homePreview: (lang: Language) =>
		[...trainingQueryKeys.lists(), 'home-preview', lang] as const,
}
